<script>
    import MultiSelect from "vue-multiselect"
    import FormInput from '../../../components/forms/FormInput.vue'
    import DateInput from '../../../components/forms/DateInput.vue'
    import NumberInput from "./NumberInput.vue"

    export default {
        components: {
            MultiSelect,
            FormInput,
            DateInput,
            NumberInput
        },
        props: {
            suffixesData: Array,
            relationshipsData: Array,
            dependentDetails: Object
        },
        data() {
            return {
                isShowDependent: false
            }
        },

        methods: {
            handleToShowDependent(value) {
                if(value === 'yes') {
                    this.isShowDependent = true
                } else {
                    this.isShowDependent = false
                }
            },
            suffixDropdownCustomLabel(option) {
                return `${option.suffix}`
            },
            relationshipDropdownCustomLabel(option) {
                return `${option.relationship}`
            },
            addDependent() {
                this.$emit('addDependnentDetails')
            },
            deleteDependent(index) {
                this.$emit('deleteDependentDetails', index)
            }
        },
    }
</script>

<template>
    <div class="form-group">
        <div class="row mb-2">
            <div class="col-12 col-md-5 p-2">
                2. Did you have any dependents (in Tax Year)?
            </div>
            <div class="col-12 col-sm-6 col-md-7 p-2">
                <div class="form-group form-check-inline">
                    <div
                        class="form-check"
                    >
                        <input
                            class="form-check-input"
                            type="radio"
                            v-model="dependentDetails.status"
                            value="yes"
                            id="dependentYes"
                            @click="handleToShowDependent('yes')"
                        />
                        <label
                            class="form-check-label"
                            for="dependentYes"
                        >
                            Yes
                        </label>
                    </div>
                </div>
                <div class="form-group form-check-inline">
                    <div
                        class="form-check"
                    >
                        <input
                            class="form-check-input"
                            type="radio"
                            v-model="dependentDetails.status"
                            value="No"
                            id="dependentNo"
                            @click="handleToShowDependent('No')"
                        />
                        <label
                            class="form-check-label"
                            for="dependentNo"
                        >
                            No
                        </label>
                    </div>
                </div>
            </div>
        </div>
        <template v-if="isShowDependent">
            <div class="row mb-2" v-for="(item, index) in dependentDetails.dependents" :key="index">
                <div class="col-12 col-sm-6 col-md-3 p-2">
                    <FormInput 
                        title="Full Name" 
                        v-model='item.name'
                        :required="true" 
                        :error="item.nameError" 
                        type="text" 
                        name="name" 
                    />
                </div>

                <div class="col-12 col-sm-6 col-md-3 p-2">
                    <FormInput 
                        title="Middle Initial" 
                        v-model='item.middleInitial'
                        :required="false" 
                        :error="item.middleInitialError" 
                        type="text" 
                        name="middleInitial" 
                    />
                </div>
                <div class="col-12 col-sm-6 col-md-3 p-2">
                    <label>
                        Suffix
                    </label>
                    <MultiSelect 
                        v-model="item.suffix"
                        :custom-label="suffixDropdownCustomLabel"
                        :select-label="''"
                        :options="suffixesData"
                        track-by="id"
                        placeholder="Select Suffix"
                    >
                    </MultiSelect>
                </div>

                <div class="col-12 col-sm-6 col-md-3 p-2">
                    <NumberInput 
                        title="SSN or ITIN"
                        placeholder="SSN or ITIN"
                        v-model='item.ssn'
                        :required="false" 
                        :error="item.ssnError"
                        :maximumlength="9"
                    />
                </div>
                <div class="col-12 col-sm-6 col-md-5 p-2">
                    <DateInput 
                        title="Date of Birth" 
                        v-model='item.dob' 
                        :required="true" 
                        :error="item.dobError" 
                        :disabledDate="(date) => date >= new Date()" 
                    />
                </div>
                <div class="col-12 col-sm-6 col-md-5 p-2">
                    <label>
                        Relationship to you
                        <span class="text-danger">*</span>
                    </label>
                    <MultiSelect 
                        v-model="item.relationship"
                        :custom-label="relationshipDropdownCustomLabel"
                        :select-label="''"
                        :options="relationshipsData"
                        track-by="id"
                        placeholder="Select Relationship"
                    >
                    </MultiSelect>
                    <div
                        v-if="item.relationshipError"
                        class="text-danger"
                        style="font-size: 80%;position: absolute;"
                    >
                        {{ item.relationshipError }}
                    </div>
                </div>
                <div v-if="index > 0" class="col-12 col-sm-6 col-md-2 mb-2 pb-1 align-self-end">
                    <div class="d-grid">
                        <button @click="deleteDependent(index)" type="button" class="btn btn-danger waves-effect waves-light">
                            <i class="mdi mdi-trash-can d-block"></i>
                        </button>
                    </div>
                </div>
            </div>                                              
            <button type="button" class="btn btn-success waves-effect waves-light" @click="addDependent">Add Dependent</button>
        </template>
    </div>
</template>